import {
  POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES,
  INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP,
  POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES,
  OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP,
  INFRASTRUCTURE_TYPE_TO_TITLE_MAP,
} from '../constants/infrastructure';
import { ITAInfrastructure, TTAInfrastructureItem } from '../types/map';

export const transformTransportAccessibilityInfrastructure = (
  response: ITAInfrastructure,
): ITAInfrastructure | undefined => {
  if (!response) {
    return undefined;
  }

  const { inside, outside } = response;

  const outsideResult: Record<string, TTAInfrastructureItem[]> = {};
  const insideResult: Record<string, TTAInfrastructureItem[]> = {};

  if (outside) {
    POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES.forEach(infrastructureType => {
      const property = OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP[infrastructureType];
      const responseItems = outside[property];

      if (Array.isArray(responseItems)) {
        outsideResult[property] = responseItems.map(item => ({
          ...item,
          type: infrastructureType,
          title: item.title || INFRASTRUCTURE_TYPE_TO_TITLE_MAP[infrastructureType],
        }));
      }
    });
  }

  if (inside) {
    POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES.forEach(infrastructureType => {
      const property = INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP[infrastructureType];
      const responseItems = inside[property];

      if (Array.isArray(responseItems)) {
        const resultItems = responseItems.map(item => ({
          ...item,
          type: infrastructureType,
          title: item.title || INFRASTRUCTURE_TYPE_TO_TITLE_MAP[infrastructureType],
        }));

        insideResult[property] = resultItems;
      }
    });
  }

  return {
    inside: insideResult,
    outside: outsideResult,
  };
};
